import React, { useState, useEffect } from "react";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";

export const useQuestionOptions = (question, onOptionsLoaded) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const needsFetch =
            ["select", "multiselect"].includes(question.questionType || question.fieldType) &&
            question.options &&
            question.options.length > 0 &&
            typeof question.options[0] === 'string';

        if (needsFetch) {
            const load = async () => {
                setLoading(true);
                try {
                    const res = await getApi({ apiUrl: API_URLS.GET_QUESTION_OPTIONS(question.questionId) });
                    if (res && res.success) {
                        setOptions(res.data);
                        if (onOptionsLoaded) {
                            onOptionsLoaded(question.questionId, res.data);
                        }
                    }
                } catch (err) {
                    console.error(`Failed options load ${question.questionId}`, err);
                }
                setLoading(false);
            };
            load();
        } else {
            const opts = question.options || [];
            setOptions(opts);
            if (onOptionsLoaded && opts.length > 0) {
                onOptionsLoaded(question.questionId, opts);
            }
        }
    }, [question.questionId, question.options]);

    return { options, loading };
};

export const getOptionLabel = (questionId, optionValue, optionsCache) => {
    const cached = optionsCache?.[questionId];
    if (cached && Array.isArray(cached)) {
        const found = cached.find(opt => opt.value === optionValue);
        if (found) return found.label;
    }
    return optionValue;
};